"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDomainNameFromAbbreviation = void 0;
const constants_1 = require("../constants");
function getDomainNameFromAbbreviation(abbreviation) {
    return constants_1.DOMAIN_NAMES_CODES[abbreviation] || undefined;
}
exports.getDomainNameFromAbbreviation = getDomainNameFromAbbreviation;
//# sourceMappingURL=domainName.js.map